module.exports = __webpack_public_path__ + "static/media/clapmag.4de27c4e.gif";